import { createSimpleStore } from './simpleStoreFactory';

type GenericTemporaryFormState<T> = {
  formData: T | null;
};

type GenericTemporaryFormActions<T> = {
  setFormData: (data: T | null) => void;
  clearFormData: () => void;
};

export type GenericTemporaryFormStore<T> = GenericTemporaryFormState<T> & GenericTemporaryFormActions<T>;

export function createGenericTemporaryFormStore<T>(name: string) {
  return createSimpleStore<GenericTemporaryFormState<T>, GenericTemporaryFormActions<T>>({
    name,
    initialState: {
      formData: null
    },
    actions: (set) => ({
      setFormData: (data: T | null) => set({ formData: data }),
      clearFormData: () => set({ formData: null })
    })
  });
}
